<template>
    <div>
        <div style="min-width: 1200px;">
            <div class="header-top">
                <img src="@/assets/img/top_bg_text.jpg" class="bg-01">
                <div class="top-inner">
                    <div style="float: right;  margin-top: 80px;  margin-right: 10px;">
                        <!--<img src="./assets/img/top_write.png" class="logo">-->
                        <!--<span style="color: #ffffff" v-if="!userName">请登录</span>-->
                        <span style="color: #ffffff" v-if="userName">
                            <i class="el-icon-user-solid" style="margin-right: 3px;color: #ffffff;"></i>
                            欢迎你
                            <!--<span style="margin-left: 10px">{{loginName}}</span>-->
                        </span>
                        <span @click="goBack"  v-if="userName" type="text" style="color: #ffffff;margin-left: 20px;margin-right: 10px"> <i class="el-icon-switch-button" style="margin-right: 6px;color: #ffffff"></i>退出</span>

                    </div>
                </div>
            </div>
            <div/>
            <router-view ref="route" />

        </div>
    </div>
</template>
<script>
    export default {
        provide () {    //父组件中通过provide来提供变量，在子组件中通过inject来注入变量。
            return {
                reload: this.reload
            }
        },
        data() {
            return {
                userName:false

            }
        },
        created(){
            // if(sessionStorage.getItem('sfsmrz')!='1' || sessionStorage.getItem('sfsmrz')!='undefined'){
            //     this.userName=true
            // }
            // this.$router.push({
            //     path:'/',
            //     query: {
            //         name: '政府信息公开申sessionStorage请',
            //         id: 0
            //     }
            // })
        },
        mounted() {
            let footJS = document.createElement("script")
            footJS.src = 'https://ythzxfw.miit.gov.cn/JavaScript/footer.js'
            document.body.appendChild(footJS)
            // document.getElementById("JSFooter").style.marginLeft="25%"
        },
        watch:{
            $route(to, from) {
                if(to.path=="/apply-table-write"){
                    this.userName=true
                }else {
                    this.userName=false
                }
            }
        },

        methods: {
            reload () {
                this.isRouterAlive = false;            //先关闭，
                this.$nextTick(function () {
                    this.isRouterAlive = true;         //再打开
                })
            },

            goBack() {
                sessionStorage.clear("sfsmrz")
                sessionStorage.clear("LoginTimeSixty")
                window.open(window.SITE_CONFIG['quitUrl'],'_self')
                // this.$axios({
                //     url: '/ucenter/quit',
                //      method: 'get',
                //
                //     }).then(({data}) => {
                //     const that = this
                //     that.form = data.result
                // })
            }

        }
    }
</script>
<style lang="scss">
    .dh-page-con{
        left: 60% !important;
    }
    .header-top {
        position: relative;
        .el-radio {
            color: #ffffff;
        }

        .el-radio__input.is-checked + .el-radio__label {
            color: #ffffff;
        }

        .el-radio__input.is-checked .el-radio__inner {
            border-color: #ffffff;
            background: #ffffff;
        }

        .el-radio__inner::after {
            background: #ec6941;
            width: 8px;
            height: 8px;
        }

        .search_input {
            .el-input__inner {
                background: #cde1f7;
                padding-right: 75px;
                border-radius: 20px;
            }
        }
    }

    .bg-01 {
        width: 100%;
        vertical-align: bottom;
    }

    .top-inner {
        margin: auto;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;

        .fr {
            width: 60%;
        }

        .fl {
            width: 40%;
            /*align-items: center;*/
            /*display: flex;*/
        }

        .logo {
            /*width: 20%;*/
        }

        .logo-text {
            color: #ffffff;
            font-size: 22px;
            /*line-height: 32px;*/
            font-weight: bold;
            margin-left: 10px;
        }

        .login {
            float: right;
            color: #ffffff;
            font-size: 16px;
            margin-top: 10px;

            span {
                cursor: pointer;

                &:hover {
                    color: #ffffff;
                }
            }

            span:before {
                content: '';
                display: inline-block;
                margin-right: 5px;
            }

            .login_1:before {
                width: 16px;
                height: 16px;
                margin-top: 2px;
                margin-left: 20px;
                background: url("./assets/img/login_1.png");
            }

            .login_2:before {
                width: 20px;
                height: 20px;
                background: url("./assets/img/login_2.png");
            }
        }
    }

    .search {
        width: 500px;
        position: absolute;
        bottom: 0px;
        right: 0;
    }

    .search_input {
        width: 370px;
        margin-right: 10px;
    }

    .search_suffix {
        background: #e9ac96;
        color: #ffffff;
        width: 70px;
        height: 28px;
        margin-top: 2px;
        border-radius: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        margin-right: -2px;
    }

    .nav-inner {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        line-height: 100%;
        width: 10%;
        /*width: 1200px;*/
        margin: 0 auto;

        .allCategories {
            width: 220px;
            background: #0068b7;
            color: #ffffff;
            text-align: left;
            padding-left: 40px;
        }

        span {
            color: #ffffff;
            margin: 0 30px;
            cursor: pointer;

            &.cur {
                color: black;
            }
        }
    }
</style>



